import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MemberLookupComponent } from './member-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [MemberLookupComponent],
  exports: [MemberLookupComponent],
  providers: []
})
export class MemberLookupModule { }
